<script>
import ClientesService from '@/services/clientes.service';
import Utils from '@/functions/utils';
import { EstadoContador, ESTADO_CONTADOR, ESTADO_REGISTRO_CONTADOR, PaginacionDefault, Rol, RegistroEstadoContador } from '@/constants/global';
import authService from '@/services/auth.service';
import spinnerService from '@/services/spinner.service';

export default {

  data() {
    return {
      loading: false,
      roles: Rol,
      estados: ESTADO_CONTADOR.filter(flt => flt.id != EstadoContador.PENDIENTE),
      registros: ESTADO_REGISTRO_CONTADOR,
      asesores: [],
      errores: {},
      recomendado: {},
      recomendadodb: {},
      contadordb: {},
      usuario: authService.getUser()
    }
  },
  async mounted() {
    const id = this.$route.params.id;
    if (id && (isNaN(id) || id <= 0)) {
      this.$router.push({
        path: '/not-found'
      });
      return;
    }
    await this.getUsuarios();
    await this.getRecomendadoPorId(id);
    await this.getContadorPorId(this.recomendadodb.idContador);
  },
  methods: {
    async getUsuarios() {
      let res = await ClientesService.getUsuarios(PaginacionDefault.FILTRO, PaginacionDefault.PAGINA, PaginacionDefault.SIZE, PaginacionDefault.ESTADO);
      let values = res.data || [];
      this.asesores = values.map(map => {
        return { label: map.nombre, value: map.id }
      });
    },
    async getRecomendadoPorId(id) {
      let res = await ClientesService.getRecomendadoPorId(id);
      this.recomendadodb = res;
      this.recomendado.nombreCompleto = res.nombre;
      this.recomendado.telefono = res.telefono;
      this.recomendado.ciudad = res.ciudad;
      this.recomendado.rubro = res.rubro;
      this.recomendado.comentario = res.comentario;
      this.recomendado.estado = res.estado != 0 ? res.estado : EstadoContador.REGISTRADO;
      this.recomendado.confirmacion = res.confirmacion != 0 ? res.confirmacion : RegistroEstadoContador.PENDIENTE;
    },
    async getContadorPorId(id) {
      let res = await ClientesService.getContadorPorId(id);
      this.contadordb = res;
      this.recomendado.idAsesor = res.idAsesor;
    },
    btnCancelar_click() {
      this.$router.go(-1);
    },
    async btnGuardar_click() {
      if (this.loading) return;
      //VALIDACIONES
      this.errores.idAsesor = this.recomendado.idAsesor == null || this.recomendado.idAsesor == -1;
      this.errores.nombreCompleto = this.recomendado.nombreCompleto == null || this.recomendado.nombreCompleto.trim() == '';
      this.errores.telefono = this.recomendado.telefono == null || this.recomendado.telefono.trim() == '';
      this.errores.ciudad = this.recomendado.ciudad == null || this.recomendado.ciudad.trim() == '';
      this.errores.rubro = this.recomendado.rubro == null || this.recomendado.rubro.trim() == '';
      
      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      if (existError) return;

      this.loading = true;
      spinnerService.show();
      try {
        let obj = {
          Id: this.recomendadodb.id,
          Nombre: this.recomendado.nombreCompleto,
          Telefono: this.recomendado.telefono,
          Ciudad: this.recomendado.ciudad,
          Rubro: this.recomendado.rubro,
          Comentario: this.recomendado.comentarios,

          Estado: this.recomendado.estado == 0 ? EstadoContador.REGISTRADO : this.recomendado.estado,
          Confirmacion: this.recomendado.confirmacion == 0 ? RegistroEstadoContador.PENDIENTE : this.recomendado.confirmacion,
          FechaConfirmacion: new Date(),
          IdAsesor: this.recomendado.idAsesor,

          FechaRegistro: this.recomendadodb.fechaRegistro,
          IdContador: (this.contadordb && this.contadordb.id) || 0,
          DocRecomendador: this.recomendadodb.docRecomendador,
          NombreRecomendador: this.recomendadodb.nombreRecomendador,
          TelefonoRecomendador: this.recomendadodb.telefonoRecomendador
        };

        await ClientesService.updateRecomendado(obj.Id,obj);
        Utils.mostrarMensajeExito('Se ha guardado exitosamente');
        this.loading = false;
        this.$router.push({
          path: `/`
        });
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeError(error.Message || 'Ocurrio un error')
      } finally{
        spinnerService.hide();
      }

    }
  }
};

</script>
<template>
  <div class="space"></div>
  <div class="container conts">
    <div class="row">
      <div class="col"></div>
      <div class="col-sm-9">
        <div class="recuadro bg-white mt-5 mb-5">
          <div class="text-center head bg-primary bg-gradient text-white p-4">
            <h1>EDITAR RECOMENDADO SMART</h1>
          </div>
          <div class="card-body p-5">
            <form id="regis" action="/editarRecomendado" method="POST">
              <input type="hidden" name="id_recom" id="id_recom" value="<%=recomendado.id_recom%>">
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Información del Recomendador SMART</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="cont_dni" class="form-control-lg">DNI</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" v-model="contadordb.documento" disabled>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="cont_nombre" class="form-control-lg">Nombre Completo</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" v-model="contadordb.razonSocial" disabled>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="ciudad" class="form-control-lg">Tipo</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" v-model="contadordb.ocupacion" disabled>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="ciudad" class="form-control-lg">Asesor</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="recom_asesor" id="recom_asesor" class="req form-select form-control-lg"
                      v-model="recomendado.idAsesor" :disabled="usuario.rol != roles.ADMINISTRADOR"
                      v-bind:class="{ 'invalid': errores.idasesor }">
                      <option value="-1">Seleccione un asesor</option>
                      <option v-for="asesor in asesores" :key="asesor.value" :value="asesor.value">
                        {{ asesor.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Información del Recomendado</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="nombre" class="form-control-lg">Nombre Completo</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" name="recom_nombre" id="recom_nombre" class="req form-control form-control-lg"
                      v-model="recomendado.nombreCompleto" v-bind:class="{ 'invalid': errores.nombreCompleto }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="telefono" class="form-control-lg">Telefono</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" name="recom_telefono" id="recom_telefono" class="req form-control form-control-lg"
                      v-model="recomendado.telefono" v-bind:class="{ 'invalid': errores.telefono }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="ciudad" class="form-control-lg">Ciudad</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" name="recom_ciudad" id="recom_ciudad" class="req form-control form-control-lg"
                      v-model="recomendado.ciudad" v-bind:class="{ 'invalid': errores.ciudad }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="rubro" class="form-control-lg">Rubro de su negocio</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" name="recom_rubro" id="recom_rubro" class="req form-control form-control-lg"
                      v-model="recomendado.rubro" v-bind:class="{ 'invalid': errores.rubro }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="comentarios" class="form-control-lg">Comentarios adicionales</label>
                  </div>
                  <div class="col-sm-7">
                    <textarea class="form-control form-control-lg" name="recom_comentario" id="recom_comentario" rows="3"
                      maxlength="255" placeholder="OPCIONAL" v-model="recomendado.comentario"></textarea>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Estado del registro</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="estado" class="form-control-lg">Estado</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="recom_estado" id="recom_estado" class="form-select form-control-lg" v-model="recomendado.estado">
                      <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="confirmacion" class="form-control-lg">Confirmación de registro</label>
                  </div>
                  <div class="col-sm-7">
                    <select name="recom_confirm" id="recom_confirm" class="form-select form-control-lg" v-model="recomendado.confirmacion">
                      <option v-for="registro in registros" :key="registro.id" :value="registro.id">
                        {{ registro.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <input type="hidden" name="recom_fec_confirm" id="recom_fec_confirm">
                  <div class="col"><a @click="btnCancelar_click"
                      class="btn btn-danger form-control btn-lg">Cancelar</a></div>
                  <div class="col"></div>
                  <div class="col"><button type="button" id="guardar" class="btn btn-primary form-control btn-lg"
                    @click="btnGuardar_click">Guardar</button></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>